(function () {
  'use strict';

  angular.module('ringbaPortal')
    .controller('DashboardController', DashboardController);

  function DashboardController(
    $state,
    authService,
    accountsService,
    campaignServiceNew,
    bsLoadingOverlayService,
    userSettingsService
  ) {
    const vm = this;

    vm.hideOnboardingDialog = null;
    vm.checkOnboardingStatus = false;
    vm.authentication = authService.authentication;
    vm.accountsService = accountsService;
    vm.accountModal = null;
    vm.hasAccess = accountsService.hasAccess;
    vm.showCampaigns = false;
    vm.showTargetStats = false;
    vm.showAccountStats = false;
    vm.showTopPerformers = false;

    vm.$onInit = onInit;

    function onInit() {
      if (!accountsService.currentAccounts || !accountsService.currentAccounts.length) {
        bsLoadingOverlayService.stop();
        $state.go('dashboard.account-details');
      } else {
        _showHideOnboardingDialog();
        _loadPermissions();
      }
    }

    function _loadPermissions(){
      vm.showCampaigns = !accountsService.isBuyer();
      vm.showTargetStats = !accountsService.isAffiliate();
      vm.showAccountStats = vm.hasAccess('Admin', 'ALL');
      vm.showTopPerformers = vm.hasAccess('Admin', 'ALL');
    }

    function _showHideOnboardingDialog() {
      let userSettings;

      return vm.hasAccess('Campaign', 'CREATE') && userSettingsService.getUserSettings().then(function (settings) {
        userSettings = settings || {};
        vm.hideOnboardingDialog = !!(userSettings.hideOnboardingDialog);

        return (!vm.hideOnboardingDialog && campaignServiceNew.checkIfCampaignsExistOnAccount(accountsService.currentAccountId)) || vm.hideOnboardingDialog;
      }).then(function(campaignExistsInAccount) {

        if (!vm.hideOnboardingDialog && campaignExistsInAccount) {
          vm.hideOnboardingDialog = true;
          userSettings.hideOnboardingDialog = vm.hideOnboardingDialog;
          userSettingsService.saveUserSettings(userSettings);
        }

        vm.checkOnboardingStatus = true;
      });
    }
  }
})();
